export default __webpack_public_path__ + "static/media/cetoacidosis_diabetica.2dd7a449.pdf";